import { SI, NO } from '@atresmedia/datalayer/lib/utils/constants';
import { MAX_ADBLOCK_DETECT_TIME, UNAUTHENTICATED } from './constants';

export const checkIfUserHasAdBlocker = () => {
  const detect = require('@atresmedia/adblock-detect').default; // eslint-disable-line global-require
  return detect();
};

const parseAdBlockResponse = adblockResponse => {
  let adblockActived;
  if (adblockResponse instanceof Error) {
    adblockActived = UNAUTHENTICATED;
  } else if (adblockResponse) {
    adblockActived = SI;
  } else {
    adblockActived = NO;
  }
  return adblockActived;
};

export const getAdblockActivated = () =>
  checkIfUserHasAdBlocker()
    .then(result => parseAdBlockResponse(result))
    .catch(error => {
      console.error(`Failed to check user AdBlocker. ${error}`);
      parseAdBlockResponse(error);
    });

export default () =>
  new Promise(resolve => {
    let expired = false;
    setTimeout(() => {
      expired = true;
      resolve({ adblockActived: UNAUTHENTICATED });
    }, MAX_ADBLOCK_DETECT_TIME);
    getAdblockActivated().then(adblockActived => {
      if (!expired) {
        console.log(
          `%c Adblock active ----> ${adblockActived}`,
          'background: blue; color: #bada55'
        );
        resolve({ adblockActived });
      }
    });
  });
